export const name = "STRING (Timestamp)";
export const summary = `Converts a \`TIMESTAMP\` value to a \`STRING\` value.`;
export const reference = `
## STRING (Timestamp)

Converts a \`TIMESTAMP\` value to a \`STRING\` value.

\`\`\`
STRING(timestamp_expression[, time_zone])
\`\`\`

### Description

Converts a timestamp to a string. Supports an optional parameter to specify a time zone. See Time zone definitions for information on how to specify a time zone.


### Return Data Type

\`STRING\`


### Example



\`\`\`
SELECT STRING(TIMESTAMP "2008-12-25 15:30:00+00", "UTC") AS string;

/*-------------------------------*
 | string |
 +-------------------------------+
 | 2008-12-25 15:30:00+00 |
 *-------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
